import React from "react";
import Badge from "@material-ui/core/Badge";
import { getTimeStringfromSeconds } from "../../functions";
import "./index.css";
const notification_gif = require("../../assets/media/headers/notification.gif");
const Ticket = ({ data, isNew, onSelect }) => {
  return (
    <div
      className="block-content"
      style={{ background: "white" }}
      onClick={onSelect}
    >
      <div className="row_div">
        <p>Support ticket - {data.type}</p>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: 200,
          justifyContent: "space-between",
        }}
      ></div>
      {isNew && (
        <Badge color="secondary" variant="dot" invisible={false}>
          <img src={notification_gif} width="45" alt="notification_img" />
        </Badge>
      )}
      <p>{getTimeStringfromSeconds(data.time)}</p>
    </div>
  );
};
export default Ticket;



// WEBPACK FOOTER //
// ./src/screens/AdminSupport/Ticket.js